//============================================================================
// Redux
//============================================================================
export enum OrdersActions {
  StoreInitialState,

  // Order Item
  ItemCreate,
  ItemDestroy,
  ItemDestroyAll,
  ItemUpdate,

  // Schedule Order
  ScheduleDestroy,
  ScheduleDestroyAll,
  ScheduleUpdate,
}
